import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchBillPayments } from './api';

export function useBillPayments(billId: number | null) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.billing.payments(billId ?? 0), branchVersion],
    queryFn: () => fetchBillPayments(billId as number),
    enabled: billId != null,
  });
}
